import { SVGProps, Ref, forwardRef } from 'react';

export const ClockFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5m.698 3.133h-1.4V8.41l3.971 2.207.68-1.224-3.251-1.806z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ClockFilledSize16Glyph.displayName = 'ClockFilledSize16Glyph';
